import { memo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Popup } from "../../components/Popup";
import { CvvPrepareGate } from "../../components/CvvPrepareGate";
import { FUND_REQUEST_ROUTES } from "../../constants";
import { mockCards } from "../../gallery/mockData";
import { TransferPage } from "./TransferPage";

/**
 * Gallery inspectable state: Transfer with the funding CVV prepare popup open.
 */
export const CvvPrepareGatePage = memo(() => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);
  const card = mockCards[0];

  return (
    <>
      <TransferPage />
      <Popup
        visible={visible}
        onClose={() => {
          setVisible(false);
          navigate(FUND_REQUEST_ROUTES.TRANSFER);
        }}
      >
        <CvvPrepareGate
          ns="fund-request"
          last4={card.last4 ?? "4242"}
          brand={card.brand ?? undefined}
          onClose={() => {
            setVisible(false);
            navigate(FUND_REQUEST_ROUTES.TRANSFER);
          }}
          onSubmit={() => {
            navigate(FUND_REQUEST_ROUTES.SENDING, { replace: true });
          }}
        />
      </Popup>
    </>
  );
});
